import { IonApp, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./theme/main.css";

import RouterContainer from "./router/Router";
import { StatusBar, Style } from "@capacitor/status-bar";
import { Capacitor } from "@capacitor/core";
import { Toaster } from "react-hot-toast";
import { useAuthStore } from "./stores/auth.store";
import CoinsEffect from "./effects/coinsEffect";
import { useEffect } from "react";
import PopupEffect from "./effects/popupEffect";
import HelpModal from "./components/HelpModal";
import { useAnimationStore } from "./stores/animation.store";

setupIonicReact();

const App: React.FC = () => {
  const [user, loading] = useAuthStore(state => [state.user, state.loading]);
  const loadAnimations = useAnimationStore(state => state.loadAnimations);
  useEffect(() => {
    const setStatusBar = async () => {
      if (Capacitor.isNativePlatform()) {
        await StatusBar.setStyle({ style: Style.Light });
      }
    };
    setStatusBar();
    loadAnimations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <IonApp>
      {/* {!loading && user?.uid && <ExchangeRatesEffect />} */}
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2000,
          className: "w-full",
          style: { background: "black", color: "white" }
        }}
      />
      <CoinsEffect />
      <HelpModal />

      <IonReactRouter>
        <RouterContainer />
        {!loading && user?.uid && <PopupEffect />}
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
